import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const SportLandingPage = lazyRouteComponent(() => import('../pages/sport-landing-page'))

export const sportAdsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sport-lp',
  component: SportLandingPage,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
